export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto bg-gradient-to-br from-primary-500 to-accent-500 rounded-3xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 text-center lg:text-left">
              <h2 className="text-heading text-2xl md:text-3xl text-background-50 dark:text-foreground-950 mb-4">
                移动端阅读
              </h2>
              <p className="text-sm text-background-50/90 dark:text-foreground-950/90 leading-relaxed mb-6">
                51漫画网已针对移动端全面优化，在手机浏览器中打开即可享受与APP无异的流畅阅读体验。
                下拉式阅读、夜间模式、书签收藏等全部功能在移动端完美适配，无需下载任何应用。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <div className="flex items-center gap-2 px-5 py-3 bg-background-50/20 backdrop-blur-sm rounded-xl">
                  <i className="ri-smartphone-line text-background-50 dark:text-foreground-950 text-xl"></i>
                  <span className="text-sm text-background-50 dark:text-foreground-950 font-medium">打开即用</span>
                </div>
                <div className="flex items-center gap-2 px-5 py-3 bg-background-50/20 backdrop-blur-sm rounded-xl">
                  <i className="ri-qr-code-line text-background-50 dark:text-foreground-950 text-xl"></i>
                  <span className="text-sm text-background-50 dark:text-foreground-950 font-medium">扫码访问</span>
                </div>
              </div>
            </div>
            <div className="flex-1 flex justify-center p-6 md:p-8">
              <div className="relative w-[220px] aspect-[9/16] rounded-2xl overflow-hidden border-4 border-background-50/30">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20stylized%20mobile%20phone%20screen%20mockup%20showing%20a%20manga%20comic%20reading%20interface%2C%20warm%20coral%20and%20cream%20color%20scheme%2C%20clean%20UI%20with%20manga%20panels%20visible%2C%20modern%20app-like%20design%2C%20soft%20lighting%2C%20minimalist%20aesthetic%2C%20scrolling%20view%20with%20comic%20art%20visible&width=440&height=780&seq=app-mobile&orientation=portrait"
                  alt="51漫画网移动端阅读界面"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}